import { render, staticRenderFns } from "./specCompliance.vue?vue&type=template&id=017afa5d"
import script from "./specCompliance.vue?vue&type=script&lang=js"
export * from "./specCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017afa5d')) {
      api.createRecord('017afa5d', component.options)
    } else {
      api.reload('017afa5d', component.options)
    }
    module.hot.accept("./specCompliance.vue?vue&type=template&id=017afa5d", function () {
      api.rerender('017afa5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/specCompliance.vue"
export default component.exports